import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ConfirmModal = ({
    show,
    onConfirm,
    onCancel,
    title,
    body,
    confirmLabel = 'Confirmar',
    cancelLabel = 'Cancelar',
    confirmVariant = 'primary',
}) => (
    <Modal show={show} onHide={onCancel}>
        <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{body}</Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={onCancel}>{cancelLabel}</Button>
            <Button variant={confirmVariant} onClick={onConfirm}>{confirmLabel}</Button>
        </Modal.Footer>
    </Modal>
);

export default ConfirmModal;
